import { GET_TITLE_ADMINTOOLS, POST_TITLE_ADMINTOOLS, GET_TITLE_DETAIL_ADMINTOOLS, RESET_TITLE_ADMINTOOLS, GET_TITLE_OPTIONS } from "shared/constants/ActionTypes";

const initialState = {
  dataTitle: null,
  detailTitle:null,
  optionsTitle:null
};

const titleAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TITLE_ADMINTOOLS:
      return {
        ...state,
        dataTitle: action.payload,
      };
      case GET_TITLE_OPTIONS:
      return {
        ...state,
        optionsTitle: action.payload,
      };

    case POST_TITLE_ADMINTOOLS:
      return {
        ...state,
        dataTitle: action.payload,
      };
      case GET_TITLE_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailTitle: action.payload,
        };
        case RESET_TITLE_ADMINTOOLS:
          return initialState
        default: {
          return state;
        }
  }
};

export default titleAdmintoolsReducer;
